import { db, auth } from './firebase'; 
import { doc, updateDoc, getDoc } from 'firebase/firestore';
import axios from 'axios';

const refreshURL = process.env.REACT_APP_REFRESH_API;

async function updateUserTokenInformation(newAccessToken, newRefreshToken, newEsxpiresAt) {
    try {
        const uid = auth.currentUser.uid;
        const userTokensRef = doc(db, 'users', uid);
        
        // Update the Firestore document with new tokens
        await updateDoc(userTokensRef, {
            accessToken: newAccessToken,
            refreshToken: newRefreshToken,
            expiresAt: newEsxpiresAt
        });
    
        console.log('New tokens stored successfully');
    } catch (error) {
        console.error('Error storing new tokens:', error);
        throw error; // Propagate the error to the caller
    }
}

export async function storeTokenResponse( response ) {
    try {
        const uid = auth.currentUser.uid;
        const userTokensRef = doc(db, 'users', uid);
        
        // Update the Firestore document with token response variables
        await updateDoc(userTokensRef, {
            accessToken: response.access_token,
            refreshToken: response.refresh_token,
            expiresAt: response.expires_at,
            tokenType: response.token_type
        });
    
        console.log('Token response stored successfully');
    } catch (error) {
        console.error('Error storing token response:', error);
        throw error; // Propagate the error to the caller
    }
}

export async function refreshUserTokens() {
    try {
        // Fetch current access token and refresh token
        const accessToken = await fetchAccessToken();
        const refreshToken = await fetchRefreshToken();
    
        // Check if access token is expired
        const tokenExpirationTime = await fetchTokenExpirationTime();
        console.log("time", tokenExpirationTime)
        const expirationTime = parseInt(tokenExpirationTime);
        console.log("time", expirationTime)

        // Get the current time in seconds
        const currentTime = Math.floor(Date.now() / 1000);
        console.log("time", currentTime)
        if (currentTime >= 1) {
            const data = {
                refresh_token: refreshToken,
            };

            // Access token is expired, refresh tokens
            const response = await axios.post( refreshURL , data);
            
            console.log(response);
            // Extract new tokens from response
            const newAccessToken = response.data.access_token;
            const newRefreshToken = response.data.refresh_token;
            const newExpiresAt = response.data.expires_at;
            console.log("token 1", newAccessToken);
            console.log("token 2", newRefreshToken);
            console.log("token 3", newExpiresAt);
    
            // Store the new tokens in Firestore
            await updateUserTokenInformation(newAccessToken, newRefreshToken, newExpiresAt);
            const returnValue = await fetchAccessToken();
            console.log(returnValue);
            // Return the new access token
            return returnValue;
        } else {
            // Access token is still valid, return it
            return accessToken;
        }
    } catch (error) {
        console.error('Error refreshing tokens:', error);
        throw error; // Propagate the error to the caller
    }
}

async function fetchAccessToken() {
    try {
        const uid = auth.currentUser.uid;
        const userTokensRef = doc(db, 'users', uid);
        const userTokensSnapshot = await getDoc(userTokensRef);
        if (userTokensSnapshot.exists()) {
            const userData = userTokensSnapshot.data();
            return userData.accessToken;
        } else {
            throw new Error('User tokens not found in Firestore');
        }
    } catch (error) {
        console.error('Error fetching access token:', error);
        throw error; // Propagate the error to the caller
    }
}

async function fetchRefreshToken() {
    try {
        const uid = auth.currentUser.uid;
        const userTokensRef = doc(db, 'users', uid);
        const userTokensSnapshot = await getDoc(userTokensRef);
        if (userTokensSnapshot.exists()) {
            const userData = userTokensSnapshot.data();
            return userData.refreshToken;
        } else {
            throw new Error('User tokens not found in Firestore');
        }
    } catch (error) {
        console.error('Error fetching refresh token:', error);
        throw error; // Propagate the error to the caller
    }
}

async function fetchTokenExpirationTime() {
    try {
        const uid = auth.currentUser.uid;
        const userTokensRef = doc(db, 'users', uid);
        const userTokensSnapshot = await getDoc(userTokensRef);
        if (userTokensSnapshot.exists()) {
            const userData = userTokensSnapshot.data();
            const expirationTime = userData.expiresAt;
            return expirationTime;
        } else {
            throw new Error('User tokens not found in Firestore');
        }
    } catch (error) {
        console.error('Error fetching token expiration time:', error);
        throw error; // Propagate the error to the caller
    }
}